// extracted by mini-css-extract-plugin
export default {"AttachmentUpload__extIcon":"AttachmentUpload_AttachmentUpload__extIcon__L7AUz"};